import React from 'react';
import PropTypes from 'prop-types';
import Clipboard from 'clipboard';
import { Button } from 'angieslist-react-components';
import { Track } from 'angieslist-app-platform';
import './CopyTextButton.scss';

class CopyTextButtonComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = { displayCopied: 'initial' };
  }

  componentDidMount() {
    this.clipboard = new Clipboard(`#${this.props.id}`);

    this.clipboard.on('success', (e) => {
      e.clearSelection();
    });
  }

  componentWillUnmount() {
    if (this.clipboard) this.clipboard.destroy();
  }

  props: {
    id: string,
    targetId: string,
  }

  render() {
    const {
      id, targetId, bsStyle,
    } = this.props;
    return (
      <Track>
        <Button
          id={id}
          className="copy-button"
          style={{ width: '100%', height: '40px' }}
          bsStyle={bsStyle}
          data-clipboard-target={`#${targetId}`}
          onClick={() => {
                  if (this.state.displayCopied !== 'displaying') {
                    this.setState(() => ({ displayCopied: 'displaying' }));
                    setTimeout(() => {
                      if (this.state.displayCopied === 'displaying') {
                        this.setState(() => ({ displayCopied: 'finished' }));
                      }
                    }, 2000);
                  }
                }}
        >
          <If condition={this.state.displayCopied === 'initial'}>
            <span>Copy Link</span>
          </If>
          <If condition={this.state.displayCopied === 'displaying'}>
            <span className="copy-link-button-content-fade-in">
              Copied!&nbsp;
              <span className="icon icon-check" />
            </span>
          </If>
          <If condition={this.state.displayCopied === 'finished'}>
            <span className="copy-link-button-content-fade-in">Copy Link</span>
          </If>
        </Button>
      </Track>
    );
  }
}

CopyTextButtonComponent.propTypes = {
  bsStyle: PropTypes.string,
};

CopyTextButtonComponent.defaultProps = {
  bsStyle: 'primary',
};

export default CopyTextButtonComponent;



// WEBPACK FOOTER //
// ./src/modules/store/browser/components/CopyTextButton.js